import React, { useEffect, useState } from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import * as S from './styled'
import ActionDialog from '../action-dialog'
import { CustomAlert } from '../../atoms'
import { useMutation } from "@tanstack/react-query";
import { useAppContext } from '../../../context/appContext'
import { ALERT_LEVEL } from '../../../config/constants'

const ModalConfirmIntegration = ({ open, handleClose, i18n, formData, isEdit, handleCreateIntegration, handleUpdateIntegration, onDataUpdate, isDisabledButton, setIsDisabledButton }) => {
  const { createAlert } = useAppContext()

  const [showAlert, setShowAlert] = useState(false)
  const [alert, setAlert] = useState({ message: '', severity: '' });

  useEffect(() => {
    if (alert.message) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        setShowAlert(false);
        setAlert({ message: '', severity: '' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  const mutationCreateIntegration = useMutation(handleCreateIntegration);
  const mutationUpdateIntegration = useMutation(handleUpdateIntegration);

  const handleConfirmIntegration = async (e) => {
    e && e.preventDefault();
    try {
      const integrationData = {
        candidature: formData.positionUser.id,
        provider: formData.recruitmentSource.id,
        concat_url: formData.concatUrl,
        user: formData.username,
        password: formData.passwordUser,
        keyword: formData.generatedKeyword,
        login_url: formData.ePreselecUrl,
      };
      setIsDisabledButton(true);

      if (isEdit) {
        await mutationUpdateIntegration.mutateAsync(integrationData);
      } else {
        await mutationCreateIntegration.mutateAsync(integrationData);
      }
      // onDataUpdate refresca la tabla y cierra el modal de la integración: este se cierra a la vez
      // y el aviso sale fuera, que los dos modales ya no están
      await onDataUpdate();
      handleModalClose();
      createAlert(isEdit ? i18n.keywords_rpa.successUpdateIntegration : i18n.keywords_rpa.successCreateIntegration, ALERT_LEVEL.SUCCESS);
    } catch (error) {
      if (isEdit) {
        setAlert({ message: i18n.keywords_rpa.errorUpdateIntegration, severity: 'error' });
        setShowAlert(true);
      } else {
        setAlert({ message: i18n.keywords_rpa.errorCreateIntegration, severity: 'error' });
        setShowAlert(true);
        console.error('Error durante la mutación:', error);
      }
    }
  };

  const handleModalClose = () => {
    handleClose();
  };

  const isPending = mutationCreateIntegration.isLoading || mutationUpdateIntegration.isLoading

  return (
    <ActionDialog
      open={open}
      title={isEdit ? i18n.keywords_rpa.messageConfirmDataEdit : i18n.keywords_rpa.messageConfirmData}
      onClose={handleModalClose}
      onConfirm={handleConfirmIntegration}
      cancelLabel={i18n.keywords_rpa.buttonCancelIntegration}
      confirmLabel={i18n.keywords_rpa.buttonConfirmIntegration}
      confirmDisabled={isDisabledButton}
      isPending={isPending}
    >
      <S.Data>
        <p>{i18n.keywords_rpa.titlePosition} &quot;{formData.positionUser.name}&quot;</p>
        <p>{i18n.keywords_rpa.titleSource} {formData.recruitmentSource.name}</p>
        {formData && formData.concatUrl && <p>{i18n.keywords_rpa.titleConcatUrl} {formData.concatUrl}</p>}
        <p>{i18n.keywords_rpa.titleUser} {formData.username}</p>
        <p>{i18n.keywords_rpa.titleKeyword} {formData.generatedKeyword || formData.keyword}</p>
      </S.Data>
      {showAlert && <CustomAlert severity={alert.severity} message={alert.message} />}
    </ActionDialog>
  )
}

const enharce = compose(withI18n)

export default enharce(ModalConfirmIntegration)